import moment from 'moment';
import {
    PlaceBBOrderArguments,
    PlaceTVOrderArguments,
    PlaceTVVaelgSelvOrderArguments,
    SowsOrderResponse,
} from './sows';
import { ORDER_LOCALSTORAGE_KEY } from '../utilities/cookies';

export type StartDatePreference = 'asap' | 'custom';

export type FormFields = {
    fornavn: string;
    efternavn: string;
    foedselsdag: {
        dag: number;
        maaned: number;
        aar: number;
    };
    cpr?: string;
    telefonnummer: string;
    email: string;
    emailConfirmation: string;
    startDatePreference: StartDatePreference;
    selectedStartDate: string; // Serialized moment
    wants_wifi_technician: boolean;
    give_permissions: boolean;
    accept_terms: boolean;
};

export interface LocalStorageItemWithExpiryDate {
    expires: Date;
}

export interface OrderLocalStorageItem extends LocalStorageItemWithExpiryDate {
    serializedCart: string;
    dawa_address_text: string;
    formFields: FormFields;
    payloads: {
        BB?: PlaceBBOrderArguments;
        TVPackage?: PlaceTVOrderArguments;
        TVVaelgSelv?: PlaceTVVaelgSelvOrderArguments;
    };
    responses: {
        BB?: SowsOrderResponse;
        TVPackage?: SowsOrderResponse;
        TVVaelgSelv?: SowsOrderResponse;
    };
}

export function setStoredOrder(order: OrderLocalStorageItem): void {
    window.localStorage.setItem(ORDER_LOCALSTORAGE_KEY, JSON.stringify(order));
}

export function getStoredOrder(): OrderLocalStorageItem | null {
    const serializedOrder = window.localStorage.getItem(ORDER_LOCALSTORAGE_KEY);

    if (serializedOrder) {
        const storedOrder = JSON.parse(serializedOrder);
        if (moment().isAfter(storedOrder.expires)) {
            // Remove if expired
            window.localStorage.removeItem(ORDER_LOCALSTORAGE_KEY);
            return null;
        } else {
            return storedOrder;
        }
    } else {
        return null;
    }
}
